<!-- Pug Template -->
<template lang="pug">
.tech-companies
	router-view(
		@refreshInView="refreshInView"
	)
</template>

<!-- Script -->
<script>
import {htmlToRouterLinksMixin, inViewMixin} from './mixins';
import store from './store';

const $ = jQuery;
export default {
	mixins: [htmlToRouterLinksMixin, inViewMixin],
	name: 'TechCompanies',
	data(){
		return {store}
	}
};
</script>

<!-- SCSS Style -->
<style lang="scss">
[data-in-view] {
	opacity: 0;
	transform: translateY(10px);
	transition: 1s all;
	&.fade-down {
		transform: translateY(-10px);
	}
	&.in-view {
		opacity: 1;
		transform: translateY(0);
	}
}
.card--heading {
	border-radius: 0 0 0.75rem 0.75rem;
}
</style>